import type { ReactNode } from "react";

interface PillProps {
  variant?: "default" | "signal" | "mixed" | "noise";
  children: ReactNode;
}

export function Pill({ variant = "default", children }: PillProps) {
  const className = variant === "default" ? "bios-pill" : `bios-pill ${variant}`;
  return <span className={className}>{children}</span>;
}
